import React from 'react';
import { SvgIcon } from '../../../../core/icons';
import { Translate } from '../../../../core/translate';
import Modal, { ModalBody } from '../../../components/modal/Modal';

const ProcessingModal = ({ isOpen }) => {
  return (
    <Modal
      isOpen={isOpen}
      fullscreen={true}
      className="processing-modal"
      overlayClassName="processing-modal__overlay"
      contentLabel="processing-modal"
      onRequestClose={() => {}}>
      <ModalBody innerClassName="processing-modal__container">
        <SvgIcon name="processing" className="processing-modal__icon" />
        <div className="processing-modal__label">
          <Translate value="processing.v3" />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ProcessingModal;
